/* OREN — Signature effects: patina scrub, view transitions, cart stamp */
(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* — 1 · PATINA SCRUB (product page) — */
  (function(){
    if(!document.body.classList.contains('template-product')) return;
    var first = document.querySelector('.product-gallery-item');
    var img = first && first.querySelector('img');
    if(!first || !img) return;
    var wrap = document.createElement('div');
    wrap.className = 'patina-scrub';
    wrap.innerHTML =
      '<div class="ps-head"><span class="ps-label">// Patina \u2014 see it age</span><span class="ps-year">Day 1</span></div>' +
      '<input class="ps-range" type="range" min="0" max="100" value="0" step="1" aria-label="Age the piece: day one to year three">' +
      '<div class="ps-marks"><span>Day 1</span><span>Year 1</span><span>Year 3</span></div>';
    first.insertAdjacentElement('afterend', wrap);
    var range = wrap.querySelector('.ps-range');
    var yearEl = wrap.querySelector('.ps-year');
    function label(v){
      if(v < 8) return 'Day 1';
      if(v < 30) return 'First wash';
      if(v < 55) return 'Six months';
      if(v < 80) return 'Year 1';
      return 'Year 3';
    }
    function apply(){
      var p = range.value / 100;
      img.style.filter =
        'sepia(' + (p * .32).toFixed(3) + ') ' +
        'saturate(' + (1 - p * .3).toFixed(3) + ') ' +
        'contrast(' + (1 - p * .07).toFixed(3) + ') ' +
        'brightness(' + (1 + p * .05).toFixed(3) + ')';
      yearEl.textContent = label(range.value);
      wrap.classList.toggle('aged', p > .02);
    }
    range.addEventListener('input', apply);
    apply();
  })();

  /* — 2 · VIEW TRANSITIONS: morph the product image between grid and PDP — */
  (function(){
    if(!(window.CSS && CSS.supports && CSS.supports('view-transition-name','x'))) return;
    if(reduced) return;
    document.addEventListener('click', function(e){
      var link = e.target.closest('a.fragment, a.fragment-concept, a.styled-with-card');
      if(!link) return;
      var im = link.querySelector('img');
      if(im) im.style.viewTransitionName = 'oren-product-hero';
    }, true);
    var pdpImg = document.querySelector('.product-gallery-item img');
    if(pdpImg) pdpImg.style.viewTransitionName = 'oren-product-hero';
  })();

  /* — 5 · CART STAMP — */
  (function(){
    var origFetch = window.fetch;
    window.fetch = function(input){
      var url = (typeof input === 'string') ? input : ((input && input.url) || '');
      var p = origFetch.apply(this, arguments);
      if(url.indexOf('/cart/add') !== -1){
        p.then(function(res){ if(res && res.ok) stamp(); }).catch(function(){});
      }
      return p;
    };
    function code(){
      var el = document.querySelector('.product-code-line, .code-badge, .fragment-code');
      var t = el ? el.textContent.trim() : '';
      return t || 'OREN';
    }
    var busy = false;
    function stamp(){
      if(busy) return; busy = true;
      var host = document.querySelector('.product-gallery-item');
      var el = document.createElement('div');
      el.className = 'oren-stamp' + (reduced ? ' still' : '');
      el.textContent = code() + ' // added';
      if(host){
        var r = host.getBoundingClientRect();
        var visTop = Math.max(r.top, 0);
        var visBottom = Math.min(r.bottom, window.innerHeight);
        el.style.left = (r.left + r.width / 2) + 'px';
        el.style.top = ((visTop + visBottom) / 2) + 'px';
      } else {
        el.style.left = '50%';
        el.style.top = '40%';
      }
      document.body.appendChild(el);
      setTimeout(function(){ el.classList.add('out'); }, 1100);
      setTimeout(function(){ if(el.parentNode) el.parentNode.removeChild(el); busy = false; }, 1600);
    }
  })();
})();
